export default __webpack_public_path__ + "static/media/Logo_Small_1.14a7dd75.svg";